<template>
  <section class="top-about">
    <v-scroll-animation>
      <div class="top-about__body">
        <h1 class="top-about__heading">
          <span class="top-about__heading-inner">世界でたった</span><br>
          <span class="top-about__heading-inner">ひとつの</span><br>
          <span class="top-about__heading-inner">お雛さまを</span>
        </h1>
        <div class="top-about__description">
          <p>
            ひととえでは、お人形やお道具などをご自由に組み合わせてオリジナルのお雛さまをつくることができます。
          </p>
          <p>
            お雛様は、選ぶところから楽しみがはじまります。<br>
            世界でたったひとつのお雛さまは、きっとお子さまにとって特別な宝ものとなることでしょう。
          </p>
          <p class="top-about__author">
            <a class="top-about__logo" href="/" target="_blank" rel="noopener">
              <img v-if="windowWidth >= 768" class="top-about__logo-img" src="/choice/img/common/logo-vertical.png" alt="ひととえ">
              <img v-else class="top-about__logo-img" src="/choice/img/common/logo-horizontal.svg" alt="ひととえ">
            </a>
          </p>
        </div>
      </div>
    </v-scroll-animation>
    <div class="top-about__overlay"></div>
  </section>
</template>



<script>
import { mapState } from 'vuex'

export default {
  components: {
    'v-scroll-animation': require('@/components/scroll-animation.vue').default,
  },
  computed: {
    ...mapState({
      windowWidth: state => state.window.width,
    })
  },
}
</script>



<style lang="scss">
.top-about {
  $e: &;
  position: relative;
  background-color: $accent-color-bg;
  margin-top: -300px;
  padding-top: 360px;
  padding-bottom: 64px;
  @include breakpoints-min(md) {
    background: linear-gradient(to left, #f8e9ea 630px, #faeced,  #fff);
    margin-top: -300px;
    padding-top: 380px;
    padding-bottom: 80px;
  }
  &__body {
    position: relative;
    z-index: 1;
    width: 100%;
    @include breakpoints-min(md) {
      display: flex;
      justify-content: center;
      flex-direction: row-reverse;
      padding-top: 32px;
      padding-bottom: 32px;
    }
    @include breakpoints-min(lg) {
      background-color: transparent;
    }
  }
  &__heading {
    font-family: $serif;
    font-size: 22px;
    font-weight: 400;
    text-align: center;
    line-height: 1;
    letter-spacing: 0.175em;
    margin-left: 20px;
    margin-right: 20px;
    @include breakpoints-min(md) {
      width: 176px;
      writing-mode: vertical-rl;
      font-size: 24px;
      text-align: left;
      margin-left: 16px;
      margin-right: 0;
    }
  }
  &__heading-inner {
    display: inline-block;
    margin-bottom: 28px;
    @include breakpoints-min(md) {
      border-radius: 3px;
      background-color: #fff;
      writing-mode: vertical-rl;
      margin-bottom: 0;
      margin-left: 16px;
      padding: 12px 8px;
    }
  }
  &__description {
    font-family: $serif;
    font-size: 15px;
    line-height: 2.3;
    letter-spacing: 0.17em;
    margin: 20px 20px 0;
    @include breakpoints-min(md) {
      writing-mode: vertical-rl;
      text-align: justify;
      text-justify: inter-ideograph;
      font-size: 15px;
      line-height: 2.6;
      letter-spacing: 0.17em;
      height: 264px;
      margin: 0;
    }
    p {
      margin: 24px 0 0;
      @include breakpoints-min(md) {
        text-indent: 1em;
        margin: 0 32px;
      }
    }
    #{$e}__author {
      text-align: right;
      margin-top: 32px;
      @include breakpoints-min(md) {
        text-align: right;
        margin: 0 72px 0 0;
      }
    }
  }
  &__logo {
    display: inline-block;
    transition: $transition;
    width: 128px;
    @include active() {
      opacity: 0.7;
    }
    @include breakpoints-min(md) {
      text-align: right;
      width: 36px;
      @include hover() {
        opacity: 0.7;
      }
    }
  }
  &__logo-img {
    display: block;
    width: 100%;
  }

  .scroll-animation {
    #{$e}__heading-inner {
      transition: transform 1.4s ease-out, opacity 0.8s ease-out;
      transform: translateY(-32px);
      opacity: 0;
    }
    #{$e}__description {
      transition: transform 1.4s 0.8s ease-out, opacity 0.8s 0.8s ease-out;
      transform: translateY(-32px);
      opacity: 0;
    }
    #{$e}__author {
      transition: transform 1.4s 1.6s ease-out, opacity 0.8s 1.6s ease-out;
      transform: translateY(-32px);
      opacity: 0;
    }

    &.is-visible {
      #{$e}__heading-inner,
      #{$e}__description,
      #{$e}__author {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
  &__overlay {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;
    background-color: rgba(#fff, 0.725);
    @include breakpoints-min(md) {
      display: block;
    }
    @include breakpoints-min(lg) {
      display: none;
    }
  }
}
</style>
